export const UPDATE_CART = 'UPDATE_CART';
export const DELETE_CART = 'DELETE_CART';
export const UPDATE_CART_BILL = 'UPDATE_CART_BILL';
export const DELETE_CART_BILL = 'DELETE_CART_BILL';
export const REDEEM_REWARD = 'REDEEM_REWARD';
export const CART_LOADER = 'CART_LOADER';
export const UPDATE_LOYALITY = 'UPDATE_LOYALITY';
